import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { AppMainComponent } from './app.main.component';
import { AccountService } from '../services/account.service';
import { IndicateurModel } from '../models/IndicateurModel';
import { IndicateurStrategiqueModel } from '../models/IndicateurStrategiqueModel';
import { CommonApiService } from '../web-api-services/common.service';
import { IndicateurApiService } from '../web-api-services/indicateur.service';
import { SettingsService } from '../services/settings.service';
import { ConfigurationService } from '../services/configuration.service';
import { AideService } from '../aide/aide.service';
import { PermissionService } from '../services/permission.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
  isAuthentificated = false;
  model: any[];
  indicateurs: IndicateurModel[] = null;
  indicateursStrategiques: IndicateurStrategiqueModel[] = null;

  constructor(
    public app: AppMainComponent,
    private accountService: AccountService,
    private commonApiService: CommonApiService,
    public settingsService: SettingsService,
    private indicateurApiService: IndicateurApiService,
    public configurationService: ConfigurationService,
    public aideService: AideService,
    private permissionService: PermissionService,
  ) {}

  ngOnInit() {
    this.getUtilisateurInfo();
    this.accountService.isLogged.subscribe(isLogged => {
      this.isAuthentificated = isLogged;
      this.getUtilisateurInfo();
      this.initModel();
    });

    forkJoin([this.commonApiService.getIndicateurs(), this.indicateurApiService.getIndicateursStrategiques()]).subscribe(indicateursIndicateursStrategiques => {
      this.indicateurs = indicateursIndicateursStrategiques[0];
      this.indicateursStrategiques = indicateursIndicateursStrategiques[1];
      this.initModel();
    });
  }

  toggleMenu() {
    this.settingsService.MenuIsStatic = !this.settingsService.MenuIsStatic;
    this.app.staticMenuActive = this.settingsService.MenuIsStatic;
  }

  initModel() {
    if (this.indicateurs != null && this.isAuthentificated) {
      let indicateursMapped: IndicateurModel[] = [];
      this.indicateurs.forEach(i => {
        indicateursMapped[i.Id] = i;
      });
      let indicateursStrategiquesMapped: IndicateurStrategiqueModel[] = [];
      this.indicateursStrategiques.forEach(i => {
        indicateursStrategiquesMapped[i.Id] = i;
      });
      const navigation = this.configurationService.navigation;

      this.model = [
        { ...navigation.accueil, codeAide: 'app.menu.component.accueil' },
        {
          ...navigation.saisieDonnees,
          visibleFunction: () => this.permissionService.canViewSaisieDonnees,
          codeAide: 'home.home.component.saisie',
          items: [
            {
              ...navigation.formation,
              codeAide: 'home.home.component.formation',
              items: [
                {
                  ...navigation.editionFormations,
                  codeAide: 'home.home.component.editformation',
                  items: [
                    { ...navigation.formationsForomes, queryParams: { isForomes: 1 }, codeAide: 'home.home.component.formationforomes' },
                    { ...navigation.autresFormations, queryParams: { isNotForomes: 1 }, codeAide: 'home.home.component.formationautres' }
                  ],
                  visibleFunction: () => this.permissionService.canViewFormation
                },
                {
                  label: `${indicateursStrategiquesMapped[1].Nom} : ${indicateursStrategiquesMapped[1].Description}`,
                  icon: '',
                  codeAide: 'home.home.component.indicateurstrategique' + indicateursStrategiquesMapped[1].Code,
                  items: [
                    {
                      label: indicateursMapped[1].Code + '. ' + indicateursMapped[1].Nom + ' - Prévision',
                      icon: '',
                      routerLink: ['/prevision'],
                      queryParams: { id: 1 },
                      visibleFunction: () => this.permissionService.canViewPrevision(1),
                      codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[1].Code
                    },
                    {
                      label: indicateursMapped[1].Code + '. ' + indicateursMapped[1].Nom + ' - Réalisé',
                      icon: '',
                      routerLink: ['/realise'],
                      queryParams: { id: 1 },
                      visibleFunction: () => this.permissionService.canViewRealise(1),
                      codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[1].Code
                    },
                    {
                      label: indicateursMapped[2].Code + '. ' + indicateursMapped[2].Nom + ' - Prévision',
                      icon: '',
                      routerLink: ['/prevision'],
                      queryParams: { id: 2 },
                      visibleFunction: () => this.permissionService.canViewPrevision(2),
                      codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[2].Code
                    },
                    {
                      label: indicateursMapped[2].Code + '. ' + indicateursMapped[2].Nom + ' - Réalisé',
                      icon: '',
                      routerLink: ['/realise'],
                      queryParams: { id: 2 },
                      visibleFunction: () => this.permissionService.canViewRealise(2),
                      codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[2].Code
                    },
                    {
                      label: indicateursMapped[3].Code + '. ' + indicateursMapped[3].Nom + ' - Prévision',
                      icon: '',
                      routerLink: ['/prevision'],
                      queryParams: { id: 3 },
                      visibleFunction: () => this.permissionService.canViewPrevision(3),
                      codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[3].Code
                    },
                    {
                      label: indicateursMapped[3].Code + '. ' + indicateursMapped[3].Nom + ' - Réalisé',
                      icon: '',
                      routerLink: ['/realise'],
                      queryParams: { id: 3 },
                      visibleFunction: () => this.permissionService.canViewRealise(3),
                      codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[3].Code
                    },
                    {
                      label: indicateursMapped[4].Code + '. ' + indicateursMapped[4].Nom + ' - Prévision',
                      icon: '',
                      routerLink: ['/prevision'],
                      queryParams: { id: 4 },
                      visibleFunction: () => this.permissionService.canViewPrevision(4),
                      codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[4].Code
                    },
                    {
                      label: indicateursMapped[4].Code + '. ' + indicateursMapped[4].Nom + ' - Réalisé',
                      icon: '',
                      routerLink: ['/realise'],
                      queryParams: { id: 4 },
                      visibleFunction: () => this.permissionService.canViewRealise(4),
                      codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[4].Code
                    }
                  ],
                  visibleFunction: () =>
                    this.permissionService.canViewPrevision(1) ||
                    this.permissionService.canViewRealise(1) ||
                    this.permissionService.canViewPrevision(2) ||
                    this.permissionService.canViewRealise(2) ||
                    this.permissionService.canViewPrevision(3) ||
                    this.permissionService.canViewRealise(3) ||
                    this.permissionService.canViewPrevision(4) ||
                    this.permissionService.canViewRealise(4)
                },
                {
                  label: `${indicateursStrategiquesMapped[2].Nom} : ${indicateursStrategiquesMapped[2].Description}`,
                  icon: '',
                  codeAide: 'home.home.component.indicateurstrategique' + indicateursStrategiquesMapped[2].Code,
                  items: [
                    {
                      label: indicateursMapped[5].Code + '. ' + indicateursMapped[5].Nom + ' - Prévision',
                      icon: '',
                      routerLink: ['/prevision'],
                      queryParams: { id: 5 },
                      visibleFunction: () => this.permissionService.canViewPrevision(5),
                      codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[5].Code
                    },
                    {
                      label: indicateursMapped[5].Code + '. ' + indicateursMapped[5].Nom + ' - Réalisé',
                      icon: '',
                      routerLink: ['/realise'],
                      queryParams: { id: 5 },
                      visibleFunction: () => this.permissionService.canViewRealise(5),
                      codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[5].Code
                    },
                    {
                      label: indicateursMapped[6].Code + '. ' + indicateursMapped[6].Nom + ' - Prévision',
                      icon: '',
                      routerLink: ['/prevision'],
                      queryParams: { id: 6 },
                      visibleFunction: () => this.permissionService.canViewPrevision(6),
                      codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[6].Code
                    },
                    {
                      label: indicateursMapped[6].Code + '. ' + indicateursMapped[6].Nom + ' - Réalisé',
                      icon: '',
                      routerLink: ['/realise'],
                      queryParams: { id: 6 },
                      visibleFunction: () => this.permissionService.canViewRealise(6),
                      codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[6].Code
                    }
                  ],
                  visibleFunction: () => this.permissionService.canViewPrevision(5) || this.permissionService.canViewRealise(5) || this.permissionService.canViewPrevision(6) || this.permissionService.canViewRealise(6)
                }
              ],
              visibleFunction: () =>
                this.permissionService.canViewRealise(1) ||
                this.permissionService.canViewRealise(2) ||
                this.permissionService.canViewRealise(3) ||
                this.permissionService.canViewPrevision(1) ||
                this.permissionService.canViewRealise(1) ||
                this.permissionService.canViewPrevision(2) ||
                this.permissionService.canViewRealise(2) ||
                this.permissionService.canViewPrevision(3) ||
                this.permissionService.canViewRealise(3) ||
                this.permissionService.canViewPrevision(4) ||
                this.permissionService.canViewRealise(4) ||
                this.permissionService.canViewPrevision(5) ||
                this.permissionService.canViewRealise(5) ||
                this.permissionService.canViewPrevision(6) ||
                this.permissionService.canViewRealise(6)
            },
            {
              ...navigation.hautNiveau,
              codeAide: 'home.home.component.hautniveau',
              items: [
                {
                  label: indicateursMapped[7].Code + '. ' + indicateursMapped[7].Nom + ' - Prévision',
                  icon: '',
                  routerLink: ['/prevision'],
                  queryParams: { id: 7 },
                  visibleFunction: () => this.permissionService.canViewPrevision(7),
                  codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[7].Code
                },
                {
                  label: indicateursMapped[7].Code + '. ' + indicateursMapped[7].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 7 },
                  visibleFunction: () => this.permissionService.canViewRealise(7),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[7].Code
                },
                {
                  label: indicateursMapped[8].Code + '. ' + indicateursMapped[8].Nom + ' - Prévision',
                  icon: '',
                  routerLink: ['/prevision'],
                  queryParams: { id: 8 },
                  visibleFunction: () => this.permissionService.canViewPrevision(8),
                  codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[8].Code
                },
                {
                  label: indicateursMapped[8].Code + '. ' + indicateursMapped[8].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 8 },
                  visibleFunction: () => this.permissionService.canViewRealise(8),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[8].Code
                },
                {
                  label: indicateursMapped[9].Code + '. ' + indicateursMapped[9].Nom + ' - Prévision',
                  icon: '',
                  routerLink: ['/prevision'],
                  queryParams: { id: 9 },
                  visibleFunction: () => this.permissionService.canViewPrevision(9),
                  codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[9].Code
                },
                {
                  label: indicateursMapped[9].Code + '. ' + indicateursMapped[9].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 9 },
                  visibleFunction: () => this.permissionService.canViewRealise(9),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[9].Code
                },
                {
                  label: indicateursMapped[10].Code + '. ' + indicateursMapped[10].Nom + ' - Prévision',
                  icon: '',
                  routerLink: ['/prevision'],
                  queryParams: { id: 10 },
                  visibleFunction: () => this.permissionService.canViewPrevision(10),
                  codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[10].Code
                },
                {
                  label: indicateursMapped[10].Code + '. ' + indicateursMapped[10].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 10 },
                  visibleFunction: () => this.permissionService.canViewRealise(10),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[10].Code
                }
              ],
              visibleFunction: () =>
                this.permissionService.canViewPrevision(7) ||
                this.permissionService.canViewRealise(7) ||
                this.permissionService.canViewPrevision(8) ||
                this.permissionService.canViewRealise(8) ||
                this.permissionService.canViewPrevision(9) ||
                this.permissionService.canViewRealise(9) ||
                this.permissionService.canViewPrevision(10) ||
                this.permissionService.canViewRealise(10)
            },
            {
              ...navigation.expertise,
              codeAide: 'home.home.component.expertise',
              items: [
                {
                  label: indicateursMapped[11].Code + '. ' + indicateursMapped[11].Nom + ' - Prévision',
                  icon: '',
                  routerLink: ['/prevision'],
                  queryParams: { id: 11 },
                  visibleFunction: () => this.permissionService.canViewPrevision(11),
                  codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[11].Code
                },
                {
                  label: indicateursMapped[11].Code + '. ' + indicateursMapped[11].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 11 },
                  visibleFunction: () => this.permissionService.canViewRealise(11),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[11].Code
                }
              ],
              visibleFunction: () => this.permissionService.canViewPrevision(11) || this.permissionService.canViewRealise(11)
            },
            {
              ...navigation.gestion,
              codeAide: 'home.home.component.gestion',
              items: [
                {
                  label: indicateursMapped[12].Code + '. ' + indicateursMapped[12].Nom + ' - Prévision',
                  icon: '',
                  routerLink: ['/prevision'],
                  queryParams: { id: 12 },
                  visibleFunction: () => this.permissionService.canViewPrevision(12),
                  codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[12].Code
                },
                {
                  label: indicateursMapped[12].Code + '. ' + indicateursMapped[12].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 12 },
                  visibleFunction: () => this.permissionService.canViewRealise(12),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[12].Code
                },
                {
                  ...navigation.formationsContinues,
                  visibleFunction: () => this.permissionService.canViewRealise(13),
                  codeAide: 'home.home.component.formationscontinues'
                },
                {
                  label: indicateursMapped[13].Code + '. ' + indicateursMapped[13].Nom + ' - Prévision',
                  icon: '',
                  routerLink: ['/prevision'],
                  queryParams: { id: 13 },
                  visibleFunction: () => this.permissionService.canViewPrevision(13),
                  codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[13].Code
                },
                {
                  label: indicateursMapped[13].Code + '. ' + indicateursMapped[13].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 13 },
                  visibleFunction: () => this.permissionService.canViewRealise(13),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[13].Code
                },
                {
                  label: indicateursMapped[18].Code + '. ' + indicateursMapped[18].Nom + ' - Prévision',
                  icon: '',
                  routerLink: ['/prevision'],
                  queryParams: { id: 18 },
                  visibleFunction: () => this.permissionService.canViewPrevision(14),
                  codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[14].Code
                },
                {
                  label: indicateursMapped[18].Code + '. ' + indicateursMapped[18].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 18 },
                  visibleFunction: () => this.permissionService.canViewRealise(18),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[14].Code
                },
                {
                  label: indicateursMapped[14].Code + '. ' + indicateursMapped[14].Nom + ' - Prévision',
                  icon: '',
                  routerLink: ['/prevision'],
                  queryParams: { id: 14 },
                  visibleFunction: () => this.permissionService.canViewPrevision(14),
                  codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[14].Code
                },
                {
                  label: indicateursMapped[14].Code + '. ' + indicateursMapped[14].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 14 },
                  visibleFunction: () => this.permissionService.canViewRealise(14),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[14].Code
                },
                {
                  label: indicateursMapped[15].Code + '. ' + indicateursMapped[15].Nom + ' - Prévision',
                  icon: '',
                  routerLink: ['/prevision'],
                  queryParams: { id: 15 },
                  visibleFunction: () => this.permissionService.canViewIndicateur44(),
                  codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[15].Code
                },
                {
                  label: indicateursMapped[15].Code + '. ' + indicateursMapped[15].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 15 },
                  visibleFunction: () => this.permissionService.canViewIndicateur44(),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[15].Code
                },
                {
                  label: indicateursMapped[17].Code + '. ' + indicateursMapped[17].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 17 },
                  visibleFunction: () => this.permissionService.canViewIndicateur44(),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[17].Code
                },
                {
                  label: indicateursMapped[16].Code + '. ' + indicateursMapped[16].Nom + ' - Prévision',
                  icon: '',
                  routerLink: ['/prevision'],
                  queryParams: { id: 16 },
                  visibleFunction: () => this.permissionService.canViewPrevision(16),
                  codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[16].Code
                },
                {
                  label: indicateursMapped[16].Code + '. ' + indicateursMapped[16].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 16 },
                  visibleFunction: () => this.permissionService.canViewRealise(16),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[16].Code
                },
                {
                  label: indicateursMapped[19].Code + '. ' + indicateursMapped[19].Nom + ' - Prévision',
                  icon: '',
                  routerLink: ['/prevision'],
                  queryParams: { id: 19 },
                  visibleFunction: () => this.permissionService.canViewPrevision(19),
                  codeAide: 'home.home.component.indicateurprevision' + indicateursMapped[19].Code
                },
                {
                  label: indicateursMapped[19].Code + '. ' + indicateursMapped[19].Nom + ' - Réalisé',
                  icon: '',
                  routerLink: ['/realise'],
                  queryParams: { id: 19 },
                  visibleFunction: () => this.permissionService.canViewRealise(19),
                  codeAide: 'home.home.component.indicateurrealise' + indicateursMapped[19].Code
                }
              ],
              visibleFunction: () =>
                this.permissionService.canViewPrevision(12) ||
                this.permissionService.canViewRealise(12) ||
                this.permissionService.canViewPrevision(13) ||
                this.permissionService.canViewRealise(13) ||
                this.permissionService.canViewPrevision(14) ||
                this.permissionService.canViewRealise(14) ||
                this.permissionService.canViewIndicateur44() ||
                this.permissionService.canViewRealise(16) ||
                this.permissionService.canViewPrevision(16) ||
                this.permissionService.canViewRealise(17) ||
                this.permissionService.canViewPrevision(17) ||
                this.permissionService.canViewRealise(18) ||
                this.permissionService.canViewPrevision(18) ||
                this.permissionService.canViewRealise(19) ||
                this.permissionService.canViewPrevision(19)
            }
          ]
        },
        {
          ...navigation.transmission,
          visibleFunction: () => this.permissionService.canViewPrevisionOrRealiseTransmission,
          codeAide: 'home.home.component.transmission',
          items: [
            { ...navigation.transmissionPrevision, visibleFunction: () => this.permissionService.canViewPrevisionTransmission, codeAide: 'home.home.component.transmissionprevision' },
            { ...navigation.transmissionRealise, visibleFunction: () => this.permissionService.canViewRealiseTransmission, codeAide: 'home.home.component.transmissionrealise' }
          ]
        },
        {
          ...navigation.validation,
          visibleFunction: () => this.permissionService.canViewValidationTransmission,
          codeAide: 'home.home.component.validation',
          items: [{ ...navigation.validationPrevision, visibleFunction: () => this.permissionService.canViewValidationTransmission, codeAide: 'home.home.component.validationprevision' }]
        },
        { ...navigation.alerteMail, visibleFunction: () => this.permissionService.canViewAlerteMailPermission, codeAide: 'home.home.component.alertemail' },
        {
          ...navigation.tableauxDeBord,
          visibleFunction: () => this.permissionService.canViewTableau,
          codeAide: 'home.home.component.tableauxdebord',
          items: [
            { ...navigation.tableauIndicateursNationauxDePerformance, visibleFunction: () => this.permissionService.canViewTableauIndicateur, codeAide: 'home.home.component.tableauxdebordindicateursnationauxdeperformance' },
            { ...navigation.tableauDeBordEtablissements, visibleFunction: () => this.permissionService.canViewTableauEtablissements, codeAide: 'home.home.component.tableauxdebordtableaudebordetablissements' },
            { ...navigation.tableauDeBordFormations, visibleFunction: () => this.permissionService.canViewTableauFormation, codeAide: 'home.home.component.tableauxdebordtableaudebordformations' }
          ]
        },
        {
          ...navigation.administration,
          visibleFunction: () => this.permissionService.canViewAdministration,
          codeAide: 'home.home.component.administration',
          items: [
            { ...navigation.roles, visibleFunction: () => this.permissionService.canViewRoles, codeAide: 'home.home.component.administrationroles' },
            { ...navigation.utilisateurs, visibleFunction: () => this.permissionService.canViewUtilisateurs, codeAide: 'home.home.component.administrationutilisateurs' },
            { ...navigation.objectifs, visibleFunction: () => this.permissionService.canViewEditObjectif, codeAide: 'home.home.component.administrationobjectifs' },
            { ...navigation.metadataPrevision, visibleFunction: () => this.permissionService.canViewEditMeta, codeAide: 'home.home.component.administrationmetadataprevision' },
            { ...navigation.metadataRealise, visibleFunction: () => this.permissionService.canViewEditMeta, codeAide: 'home.home.component.administrationmetadatarealise' },
            { ...navigation.actualites, visibleFunction: () => this.permissionService.canViewActualites, codeAide: 'home.home.component.administrationactualites' },
            { ...navigation.parametresSite, visibleFunction: () => this.permissionService.canViewAdministrationParametre, codeAide: 'home.home.component.administrationparametressite' },
            { ...navigation.editionTutoriel, visibleFunction: () => this.permissionService.canViewAdministrationParametre, codeAide: 'home.home.component.administrationeditiontutoriel' },
            { ...navigation.repartitionEtablissements, visibleFunction: () => this.permissionService.canViewEtablissementEmail, codeAide: 'home.home.component.administrationrepartitionetablissements' },
            { ...navigation.indicateurSite, visibleFunction: () => this.permissionService.canViewAdministrationParametre, codeAide: 'home.home.component.indicateursite' },
            { ...navigation.administrationDiplomes, visibleFunction: () => this.permissionService.canViewEditDiplome, codeAide: 'home.home.component.administrationdiplomes' },
            { ...navigation.gestionEtablissements, visibleFunction: () => this.permissionService.canViewGestionEtablissements, codeAide: 'home.home.component.gestionetablissements' }
          ]
        },
        { ...navigation.mesParametres }
      ];
    }
  }

  onMenuClick() {
    this.app.menuClick = true;
  }

  getUtilisateurInfo() {
    let user = this.accountService.getUtilisateurAngular();
    if (user) {
      this.isAuthentificated = true;
    } else {
      setTimeout(() => {
        this.getUtilisateurInfo();
      }, 1000);
    }
  }

  isAdminAide(): boolean {
    return this.aideService.isAdminAide();
  }

  toggleAide() {
    if (this.aideService.displayEditAide && this.isAdminAide()) {
      this.aideService.displayEditAide = !this.aideService.displayEditAide;
    } else if (this.aideService.displayAide) {
      this.aideService.displayAide = !this.aideService.displayAide;
    } else {
      this.aideService.displayAide = true;
      if (this.isAdminAide()) {
        this.aideService.displayEditAide = true;
      }
    }
  }
}
